



































































































































































































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { HdSetting, Hd, Ms, Bp } from '@/types/hd'
import dayjs from 'dayjs'
import { EventEmitter } from 'events'

const enum EventTypes {
  CONFIRM_DONE
}

const enum ConfirmModalReactTypes {
  OK,
  CANCEL
}

const C_RED = 'red'
const C_BLUE = 'blue'
const C_GRAY = 'grayout'
const HD_PORLING_DELAY = 60 * 1000
const patientInfoKeys = [
  'prevWeight',
  'beforeWeight',
  'afterWeight',
  'beforeSbp',
  'beforeDbp',
  'afterSbp',
  'afterDbp',
  'temperature'
]
type CurrentState = Partial<Ms & Bp>
type PatientInfo = Partial<
  Pick<
    Hd,
    | 'prevWeight'
    | 'beforeWeight'
    | 'afterWeight'
    | 'beforeSbp'
    | 'beforeDbp'
    | 'afterSbp'
    | 'afterDbp'
    | 'temperature'
  >
>

@Component({
  components: {
    HdChart: () => import('@/components/hdTab/HdChart.vue'),
    ConfirmModal: () => import('@/components/common/modals/AlertModal.vue'),
    FlushMessage: () => import('@/components/common/FlushMessage.vue')
  }
})
export default class HdView extends Vue {
  @Prop(Number) patientId!: number
  $store!: ExStore
  patientInfo: PatientInfo = {}
  inputValues: PatientInfo = {}
  timeoutId?: number
  showConfirmModal = false
  events = new EventEmitter()

  get prevWeight() {
    return this.inputValues.prevWeight || this.patientInfo.prevWeight
  }

  set prevWeight(value) {
    this.inputValues.prevWeight = value
  }

  get beforeWeight() {
    return this.inputValues.beforeWeight || this.patientInfo.beforeWeight
  }

  set beforeWeight(value) {
    this.inputValues.beforeWeight = value
  }

  get afterWeight() {
    return this.inputValues.afterWeight || this.patientInfo.afterWeight
  }

  set afterWeight(value) {
    this.inputValues.afterWeight = value
  }

  get beforeSbp() {
    return this.inputValues.beforeSbp || this.patientInfo.beforeSbp
  }

  set beforeSbp(value) {
    this.inputValues.beforeSbp = value
  }

  get beforeDbp() {
    return this.inputValues.beforeDbp || this.patientInfo.beforeDbp
  }

  set beforeDbp(value) {
    this.inputValues.beforeDbp = value
  }

  get afterSbp() {
    return this.inputValues.afterSbp || this.patientInfo.afterSbp
  }

  set afterSbp(value) {
    this.inputValues.afterSbp = value
  }

  get afterDbp() {
    return this.inputValues.afterDbp || this.patientInfo.afterDbp
  }

  set afterDbp(value) {
    this.inputValues.afterDbp = value
  }

  get temperature() {
    return this.inputValues.temperature || this.patientInfo.temperature
  }

  set temperature(value) {
    this.inputValues.temperature = value
  }

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get relativeInfo() {
    return this.$store.getters['user/relativeInfo']
  }

  get isWorker() {
    return this.userInfo.isWorker
  }

  get hd() {
    const hd = this.$store.getters['hd/hd']
    if (hd) {
      this.patientInfo = this.extractPatientInfo(hd)
    }
    return hd
  }

  get isCompletedHd() {
    return this.hd && !!this.hd.afterWeight
  }

  get bpList() {
    return this.$store.getters['hd/bpList']
  }

  get msList() {
    return this.$store.getters['hd/msList']
  }

  get currentState(): CurrentState {
    return Object.assign({}, this.latestMs || {}, this.latestBp || {})
  }

  get latestMs() {
    return this.$store.getters['hd/latestMs']
  }

  get latestBp() {
    return this.$store.getters['hd/latestBp']
  }

  get setting() {
    return this.$store.getters['hd/setting']
  }

  get dialysisTimeHour() {
    const setting = this.setting
    if (setting && setting.dialysisTime) {
      return Math.floor(setting.dialysisTime / 60)
    }
    return ''
  }

  get dialysisTimeMinute() {
    const setting = this.setting
    if (setting && setting.dialysisTime) {
      return setting.dialysisTime % 60
    }
    return ''
  }

  get computedEndTime() {
    if (!this.hd || !this.hd.startDatetime || !this.setting) return ''
    return dayjs(this.hd.startDatetime)
      .add(this.setting.dialysisTime, 'm')
      .format('H時mm分')
  }

  get elapsedTime() {
    if (!this.hd || !this.hd.startDatetime || !this.latestMs) return ''
    return dayjs(this.latestMs.dialysisDatetime).diff(
      this.hd.startDatetime,
      'm'
    )
  }

  get hasNext() {
    return this.$store.getters['hd/hasNext']
  }

  get hasPrev() {
    return this.$store.getters['hd/hasPrev']
  }

  get date() {
    if (!this.hd || !this.hd.afterWeight) return ''
    return dayjs(this.hd.startDatetime).format('YYYY年M月D日')
  }

  created() {
    this.fetchHd()
  }

  fetchHd() {
    const patientId = this.userInfo.isPatientRelative
      ? this.relativeInfo?.patient.id
      : this.patientId
    if (patientId == undefined) return
    this.$store.dispatch('hd/refreshCurrentHd', {
      patientId
    })
    this.timeoutId = window.setTimeout(() => {
      this.fetchHd()
    }, HD_PORLING_DELAY)
  }

  beforeDestroy() {
    this.$store.dispatch('hd/initHd')
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId)
    }
  }

  getLimitStyle(type: string) {
    const limits = this.getLimitSetting(type)
    if (!limits) return ''
    return !limits.emg.chk && !limits.warn.chk ? C_GRAY : ''
  }

  getLimitValue({ type, high }: { type: string; high: boolean }) {
    const limits = this.getLimitSetting(type)
    if (!limits) return null
    if (limits.warn.chk) return high ? limits.warn.high : limits.warn.low
    if (limits.emg.chk) return high ? limits.emg.high : limits.emg.low
    return '-'
  }

  getLimitSetting(type: string) {
    if (!this.setting) return null
    return {
      emg: {
        chk: this.setting[`emgIsLimitchk${type}` as keyof HdSetting],
        high: this.setting[`emgLimit${type}High` as keyof HdSetting],
        low: this.setting[`emgLimit${type}Low` as keyof HdSetting]
      },
      warn: {
        chk: this.setting[`warnIsLimitchk${type}` as keyof HdSetting],
        high: this.setting[`warnLimit${type}High` as keyof HdSetting],
        low: this.setting[`warnLimit${type}Low` as keyof HdSetting]
      }
    }
  }

  extractPatientInfo(hd: Hd) {
    const info: PatientInfo = Object.assign({}, hd)
    for (const key of Object.keys(info)) {
      if (!patientInfoKeys.includes(key)) {
        delete info[key as keyof PatientInfo]
      }
    }
    return info
  }

  handleNextClick() {
    const patientId = this.userInfo.isPatientRelative
      ? this.relativeInfo?.patient.id
      : this.patientId
    if (patientId == undefined) return
    this.inputValues = {}
    this.$store.dispatch('hd/fetchNextHd', { patientId })
  }

  handlePrevClick() {
    const patientId = this.userInfo.isPatientRelative
      ? this.relativeInfo?.patient.id
      : this.patientId
    if (patientId == undefined) return
    this.inputValues = {}
    this.$store.dispatch('hd/fetchPrevHd', { patientId })
  }

  getStatusColor(type: string, value: number | null) {
    if (!value) return ''
    const { setting } = this
    if (!setting) return ''
    const limits = this.getLimitSetting(type)
    if (!limits) return ''
    if (limits.emg.chk) {
      const high = limits.emg.high
      const low = limits.emg.low
      if (high && value > high) return C_RED
      if (low && value < low) return C_BLUE
    }
    if (limits.warn.chk) {
      const high = limits.warn.high
      const low = limits.warn.low
      if (high && value > high) return C_RED
      if (low && value < low) return C_BLUE
    }
    return ''
  }

  getCurrentStateValue(type: string) {
    const state = this.currentState
    if (!state) return null
    return state[type as keyof CurrentState] || null
  }

  async save() {
    if (this.userInfo.isPatientRelative) {
      this.$store.dispatch('alert/showMessages', ['このボタンは無効です'])
      return
    }
    //TODO: エラー処理
    if (!this.hd) return
    try {
      Object.keys(this.inputValues).forEach(key => {
        this.patientInfo[key as keyof PatientInfo] = this.inputValues[
          key as keyof PatientInfo
        ]
      })
      if (Number(this.patientInfo.afterWeight) > 0) {
        await this.$api.hd.finish({
          patientId: this.patientId,
          hdId: this.hd.id,
          payload: this.patientInfo
        })
      } else {
        await this.$api.hd.update({
          patientId: this.patientId,
          hdId: this.hd.id,
          payload: this.patientInfo
        })
      }
      localStorage.setItem('message', '保存されました')
      const flushMessage: any = this.$refs.flushMessage
      flushMessage.open()
      if (Number(this.patientInfo.afterWeight) > 0) {
        await this.$api.hd.create({
          patientId: this.patientId,
          payload: {
            prevWeight: Number(this.patientInfo.afterWeight),
            settingId: this.hd.setting.id
          }
        })
        this.inputValues = {}
        await this.$store.dispatch('hd/fetchLatestHd', {
          patientId: this.patientId
        })
        await this.$store.dispatch('hd/fetchPrevHd', {
          patientId: this.patientId
        })
      } else {
        await this.$store.dispatch('hd/refreshCurrentHd', {
          patientId: this.patientId
        })
      }
    } catch (e) {
      console.error(e)
    }
  }

  async finish() {
    if (this.userInfo.isPatientRelative) {
      this.$store.dispatch('alert/showMessages', ['このボタンは無効です'])
      return
    }
    //TODO: エラー処理
    if (!this.hd) return
    try {
      Object.keys(this.inputValues).forEach(key => {
        this.patientInfo[key as keyof PatientInfo] = this.inputValues[
          key as keyof PatientInfo
        ]
      })
      if (Number(this.patientInfo.afterWeight) < 1) {
        this.$store.dispatch('alert/showMessages', ['透析後体重を入力ください'])
        return
      }
      this.showConfirmModal = true
      const result = await new Promise(resolve =>
        this.events.once(EventTypes.CONFIRM_DONE, resolve)
      )
      this.showConfirmModal = false
      if (result === ConfirmModalReactTypes.CANCEL) {
        return
      }
      await this.$api.hd.finish({
        patientId: this.patientId,
        hdId: this.hd.id,
        payload: this.patientInfo
      })
      await this.$api.hd.create({
        patientId: this.patientId,
        payload: {
          prevWeight: Number(this.patientInfo.afterWeight),
          settingId: this.hd.setting.id
        }
      })
      this.inputValues = {}
      await this.$store.dispatch('hd/fetchLatestHd', {
        patientId: this.patientId
      })
      await this.$store.dispatch('hd/fetchPrevHd', {
        patientId: this.patientId
      })
    } catch (e) {
      console.error(e)
    }
  }
  handleConfirmOk() {
    this.events.emit(EventTypes.CONFIRM_DONE, ConfirmModalReactTypes.OK)
  }

  handleConfirmCancel() {
    this.events.emit(EventTypes.CONFIRM_DONE, ConfirmModalReactTypes.CANCEL)
  }
}
